import { render, staticRenderFns } from "./ToolEditor.vue?vue&type=template&id=0cb4ef94&scoped=true&"
import script from "./ToolEditor.vue?vue&type=script&lang=js&"
export * from "./ToolEditor.vue?vue&type=script&lang=js&"
import style0 from "./ToolEditor.vue?vue&type=style&index=0&id=0cb4ef94&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0cb4ef94",
  null
  
)

export default component.exports